import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () => 'file' + (Math.floor(Math.random() * 90000000) + 10000).toString();

const DEFAULT_STATIC_ROWS = [
  ['', '', ''],
  ['', '', ''],
  ['', '', ''],
];

const initData = () => ({
  outputKey: keyAuto(),
  fileType: 'CSV',
  fileName: '',
  content: '',
  documentSourceType: 'EDITOR',
  documentContent: '',
  tabularSourceType: 'STATIC_ROWS',
  staticRowsHasHeader: true,
  staticRows: DEFAULT_STATIC_ROWS.map((r) => [...r]),
  csvHeaders: '',
  csvRowTemplate: '',
  csvDataPlaceholder: '',
  sheetName: 'Sheet1',
  columns: [{ header: '', dataKey: '' }, { header: '', dataKey: '' }, { header: '', dataKey: '' }],
  dataSourcePlaceholder: '',
});

function onLoadData(rawData) {
  return rawData;
}

const { getStore: getCreateFileStore, defaultStore } = createComponentStore({
  type: 'create_file',
  endpoint: 'create-file',
  registryKey: 'create-file',
  initData,
  onLoadData,

  extraState: () => ({
    files: [],
    fileUrl: [],
  }),

  extraActions: (set, get) => ({
    setComponentData: (component) => {
      const cd = component.componentData;
      const updates = {
        componentId: component.componentId,
        type: component.type,
      };

      if (cd) {
        const isV2 = cd.schemaVersion >= 2;
        let rawData;
        let filesSource;

        if (isV2) {
          const { schemaVersion, name, lastModified, files: f, fileUrl: fu, ...rest } = cd;
          rawData = rest;
          filesSource = { f, fu };
          updates.name = name || '';
          updates.lastModified = lastModified || '';
        } else if (cd.data != null) {
          const { files: f, fileUrl: fu, ...coreData } = cd.data;
          rawData = coreData;
          filesSource = { f, fu, cdFiles: cd.files, cdFileUrl: cd.fileUrl };
          updates.name = cd.name || '';
          updates.lastModified = cd.lastModified || '';
        } else {
          const { name, lastModified, files: f, fileUrl: fu, ...rest } = cd;
          rawData = rest;
          filesSource = { f, fu };
          updates.name = name || '';
          updates.lastModified = lastModified || '';
        }

        updates.data = onLoadData({ ...initData(), ...rawData });
        updates.files = filesSource.f ?? filesSource.cdFiles ?? [];
        updates.fileUrl = filesSource.fu ?? filesSource.cdFileUrl ?? [];
      } else {
        updates.data = initData();
        updates.files = [];
        updates.fileUrl = [];
        updates.name = '';
        updates.lastModified = '';
      }

      set(updates);
    },

    setField: (field, value) => {
      set((s) => ({ data: { ...s.data, [field]: value } }));
    },

    setFiles: (files) => set({ files }),

    setFileUrl: (fileUrl) => set({ fileUrl }),

    getTemplate: () => {
      const s = get();
      const data = { ...s.data, files: s.files, fileUrl: s.fileUrl };
      return {
        componentId: s.componentId,
        name: s.name,
        type: s.type,
        lastModified: s.lastModified,
        data,
      };
    },
  }),
});

export { getCreateFileStore };
export default defaultStore;
